import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      hideNav: false,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "homeView" */ '../views/IndexView.vue'),
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      hideNav: false,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "AboutView" */ '../views/AboutView.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue'),
  },
  {
    path: '/register',
    name: 'AccountRegister',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "AccountRegister" */ '../views/Account/AccountRegister.vue'),
  },
  {
    path: '/register-success',
    name: 'RegisterSuccess',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "RegisterSuccess" */ '../views/Account/RegisterSuccess.vue'),
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "VerifyEmail" */ '../views/Account/VerifyEmail.vue'),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "ForgotPassword" */ '../views/Account/ForgotPassword.vue'),
  },
  {
    path: '/forgotPasswordSuccess',
    name: 'ForgotPasswordSuccess',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "ForgotPasswordSuccess" */ '../views/Account/ForgotPasswordSuccess.vue'),
  },
  {
    path: '/resetPasswordConfirm',
    name: 'ResetPasswordConfirm',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "ResetPasswordConfirm" */ '../views/Account/ResetPasswordConfirm.vue'),
  },
  {
    path: '/resetPasswordConfirmSuccess',
    name: 'ResetPasswordConfirmSuccess',
    meta: {
      hideNav: true,
      hideFooter: true,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "ResetPasswordConfirmSuccess" */ '../views/Account/ResetPasswordConfirmSuccess.vue'),
  },
  {
    path: '/main',
    name: 'Main',
    redirect: '/main/dashboard',
    meta: {
      hideNav: false,
      requiresAuth: false,
    },
    component: () => import(/* webpackChunkName: "MainView" */ '../views/MainView.vue'),
    children: [
      {
        path: 'member',
        name: 'MemberCenter',
        meta: {
          hideNav: false,
          requiresAuth: false
        },
        component: () =>
            import(/* webpackChunkName: "MemberCenter" */ '../views/Account/MemberCenter.vue')
      },
      {
        path: 'dashboard',
        name: 'MainDashboard',
        meta: {
          hideNav: false,
          requiresAuth: false
        },
        component: () =>
            import(/* webpackChunkName: "MainDashboard" */ '../views/MainDashboard.vue')
      },
      {
        path: 'font/:fontId/glyph/:mode?',
        name: 'FontGlyphCreator',
        meta: {
          hideNav: false,
          requiresAuth: false
        },
        component: () =>
          import(/* webpackChunkName: "FontGlyphCreator" */ '../views/Fonts/FontGlyphCreator.vue')
      },
      {
        path: 'font/:fontId',
        name: 'FontFileManager',
        meta: {
          hideNav: false,
          requiresAuth: false
        },
        component: () =>
            import(/* webpackChunkName: "FontFileManager" */ '../views/Fonts/FontFileManager.vue')
      },
    ]
  },
  {
    path: '/*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 跳頁前檢查用戶是否已登入, 測試中...
// router.beforeEach(async(to, from, next) => {
//   const isAuthenticated = store.getters['auth/hasToken'];

//   if (!isAuthenticated && to.matched.some(record => record.meta.requiresAuth)) {
//     next('/login');
//   } else {
//     // 有 token 或者不需要資料驗證的頁面，繼續執行 ensureUser
//     await store.dispatch('auth/ensureUser');
//     next();
//   }
// });


router.afterEach(async(to) => {
  // console.log(`${JSON.stringify(to.meta)}`);
  let hideNav = false;
  if (to.meta.hideNav) {
    hideNav = true;
  }
  store.commit('SETNAVHIDE', hideNav);
  let hideFooter = false;
  if (to.meta.hideFooter) {
    hideFooter = true;
  }
  store.commit('SETFOOTERHIDE', hideFooter);
});

export default router
